import { render, staticRenderFns } from "./UserArea.vue?vue&type=template&id=2c026ff2&scoped=true"
import script from "./UserArea.vue?vue&type=script&lang=js"
export * from "./UserArea.vue?vue&type=script&lang=js"
import style0 from "./UserArea.vue?vue&type=style&index=0&id=2c026ff2&prod&lang=scss&scoped=true"
import style1 from "./UserArea.vue?vue&type=style&index=1&id=2c026ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c026ff2",
  null
  
)

export default component.exports